export { PdpPointsBoostAccordion } from './pdp-points-boost-accordion';
